module.exports = __webpack_public_path__ + "static/img/ph.7255bb5b.svg";